import {
  utils,
} from '@ama-sdk/core';
import {
  MockTraveler,
  TravelerRepository,
} from '@dapi/sdk/spec';

export const traveler: MockTraveler = {
  ...TravelerRepository.MAN,
  names: [{
    firstName: 'Dwight',
    lastName: 'Schrute',
    title: 'Mr',
    nameType: 'universal'
  }]
};
export const traveler2: MockTraveler = {
  ...TravelerRepository.MAN,
  id: 'PT2',
  dateOfBirth: new utils.Date(1975, 3, 12),
  names: [{
    firstName: 'Kent',
    lastName: 'CStraight',
    title: 'Mr',
    nameType: 'universal'
  }]
};
export const traveler3: MockTraveler = {
  ...TravelerRepository.MAN,
  id: 'PT3',
  dateOfBirth: new utils.Date(1979, 10, 2),
  names: [{
    firstName: 'Chris P',
    lastName: 'Bacon',
    title: 'Mr',
    nameType: 'universal'
  }]
};

export const childTraveler: MockTraveler = TravelerRepository.CHD;

export const femaleTraveler: MockTraveler = TravelerRepository.WOMAN;

export const infantTraveler: MockTraveler = TravelerRepository.INF;
